<div [class]="containerClass">
  <lucide-icon name="phone" [size]="24" class="hc-input__icon hc-input__icon--left" aria-hidden="true"></lucide-icon>
  <input
    type="tel"
    [id]="inputId"
    [name]="name"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [required]="required"
    [value]="value"
    [autocomplete]="autocomplete"
    class="hc-input__native"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()" />
</div>
